module.exports = __webpack_public_path__ + "static/media/basic-mobile.1553f30a.svg";